module.exports = __webpack_public_path__ + "static/media/Simulation-Centre.c6b527a0.jpg";